// Предишните причини за изписване (подсказките на „Причина"). Ключът е под
// ["inventory", "writeoffs"] — записът, редакцията и анулирането на изписване
// го инвалидират заедно със списъците, тоест новата причина се появява веднага.
// В локален режим мълчи (касата няма endpoint-а) — полето остава свободен текст.
import { useQuery } from "@tanstack/react-query";
import { getWriteoffReasons } from "../api/inventoryWriteoffReasons";
import { useIsEdgeLocal } from "./useEdgeMode";

export const useWriteoffReasons = () => {
  const isLocal = useIsEdgeLocal();
  return useQuery({
    queryKey: ["inventory", "writeoffs", "reasons"],
    queryFn: getWriteoffReasons,
    enabled: !isLocal,
    staleTime: 5 * 60_000,
    retry: false,
  });
};
